import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const GooglePayResult = () => {
  return <CommonResult />;
};

export default GooglePayResult;
